import {Component, Inject} from '@angular/core';
import {
    MODAL_DATA,
    NgbActiveModal,
    NotificationService
} from '@agilent/ui-element';
import {ACApiService, TunnelSession} from '@app/api/ac-api.service';

@Component({
    template: `
        <ag-dialog [header]="title">
            <ag-dialog-content>
                <div class="pin-code">
                    <span>{{ currentTunnelSession.aic_admin_password || "Use default password"}}</span>
                </div>
            </ag-dialog-content>
            <ag-dialog-actions>
                <span *ngIf="isLoading " id="dialog-spinner"
                      class="progress-text">Please wait...</span>
                <ag-loader class="inline-progress" [visible]="isLoading"
                           [small]="true"></ag-loader>
                <ag-button
                        type="secondary"
                        (click)="cancel()"
                        value="Close"
                        [disabled]="isLoading"
                        [class.disabled]="isLoading"
                        id="cancel-btn"></ag-button>
                <ag-button
                        type="primary"
                        id="open-remote-session-window-btn"
                        [disabled]="isLoading"
                        [class.disabled]="isLoading"
                        (click)="openDebugSessionLink()"
                        value="Proceed"></ag-button>

            </ag-dialog-actions>
        </ag-dialog>
    `,
    styles: [`
        .pin-code {
            font-size: 30px;
            margin-bottom: 20px;
            margin-top: 20px;
            text-align: center;
        }

        :host .inline-progress > ::ng-deep .loader-overlay {
            background: transparent !important;
            margin: 0;
            padding: 0;
            position: static;
            transform: scale(0.7);
        }

        .progress-text {
            color: var(--agilent-magenta);
            font-weight: 600;
        }
    `]
})

export class AicRemoteSessionDialogComponent {
    title = 'Login Password';
    isLoading: boolean;
    currentTunnelSession: TunnelSession;
    acId: number;

    constructor(@Inject(MODAL_DATA) public modalData: any,
                private activeModal: NgbActiveModal,
                private acApiService: ACApiService,
                private notificationService: NotificationService) {

        this.currentTunnelSession = modalData.tunnelSession;
    }


    cancel() {
        this.activeModal.dismiss();
    }

    async openDebugSessionLink() {
        try {

            this.isLoading = true;
            const path = 'aic-windows-desktop/';
            const debugUrl = `${this.currentTunnelSession.cockpit_url}${path}`;
            this.isLoading = false;
            this.activeModal.close();
            window.open(debugUrl, 'blank');

        }
        catch (err) {
            console.log(err);
            this.isLoading = false;
            this.notificationService.error('Could not load the URL, refresh and try again');
        }
    }
}
